import { usePlatformViewStore } from '@/store/platformViewStore';
import { useAuthStore } from '@/store/authStore';

/**
 * Returns the organisation a platform admin is currently "visiting", or
 * null for a normal org member (whose queries stay scoped purely by RLS,
 * unchanged). Read functions across services/supabase/*.ts add
 * `.eq('organisation_id', ...)` with this value ONLY when it's non-null —
 * see platform admin plan, "Service layer" section.
 */
export function getViewingOrgId(): string | null {
  return usePlatformViewStore.getState().viewingOrgId;
}

/**
 * The organisation a write should be attributed to: the signed-in member's
 * own org, or — for a Super Admin/Co-Admin editing a visited org — the
 * org being visited. None of the create* functions that use this ever had
 * an explicit organisation_id before (the column has no DB default), which
 * meant every insert into `policies`/`departments`/`doa_matrices`/
 * `doa_rules`/`decision_checks`/`compliance_reviews` was relying on a
 * NOT NULL column silently... not actually being enforced client-side —
 * fixed alongside platform-editor write support, not just for platform
 * admins.
 */
export function getEffectiveOrganisationId(): string | null {
  return useAuthStore.getState().member?.organisation_id ?? getViewingOrgId();
}
